import { Link } from "react-router-dom";
import { Toast } from 'primereact/toast';
import myCvPdf from '../data/cvFiles/avriResume.pdf';
import React, { useState, useRef, useEffect } from "react";
import { useMp3Player } from '../providers/mp3PlayerContext';

const callMeNum = '0533300845';
const email = "yoti1492@gmail.com";

const copyToClipboard = (email) => { navigator.clipboard.writeText(email) };

export default ({ notifyWithToast, toggleColorMode, isDarkMode }) => {
  const toast = useRef(null);
  const wrapperRef = useRef(null);
  const [isActive, setActive] = useState(true);
  const { toastDisplay, setToastDisplay } = useMp3Player();

  const handleToggle = () => { setActive(!isActive) };

  const useOutsideHandler = (ref) => {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target.parentElement)) {
          setActive(!!isActive);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => { document.removeEventListener("mousedown", handleClickOutside) };
    }, [ref]);
  }

  useOutsideHandler(wrapperRef);

  const openMediaPlayer = () => {
    if (!toastDisplay) {
      setToastDisplay(true);
    };
  };

  const itemStyle = {
    userSelect: "none",
    cursor: "pointer"
  };

  return (
    <>
      <Toast ref={toast} position="top-left" className="custom-toast" />

      <div className="dropdown"
        onClick={handleToggle}
        ref={wrapperRef}>

        <img alt={'appList'}
          className="profile-pic dropbtn"
          src={"https://ssl.gstatic.com/gb/images/bar/al-icon.png"}
          style={{ width: '33px', height: '33px' }}
        />
        <div
          id="drop"
          className={isActive ? "dropdown-content-cont dropdown-hide" : "dropdown-content-cont dropdown-show"}>
          <div className="drop-item" style={itemStyle}>

            <a className="drop-link"
              style={itemStyle}
              onClick={() => {
                notifyWithToast(callMeNum, '',
                  {
                    name: 'Copy it to Clipboard ..',
                    impl: (() => { copyToClipboard(callMeNum) })
                  },
                  `It's on your clipboard ..`)
              }}><img src={require(`../data/imgs/icons/app/callMe.png`)}
                alt="Call" /><p> Call </p>
            </a>

            <a className="drop-link"
              style={itemStyle}
              onClick={() => {
                notifyWithToast(email, '',
                  {
                    name: 'Copy it to Clipboard ..',
                    impl: (() => { copyToClipboard(email) })
                  },
                  `It's on your clipboard ..`)
              }}><img src={require(`../data/imgs/icons/app/email.png`)}
                alt="Email" /><p> Email </p>
            </a>

            <a className="drop-link" style={itemStyle} href={myCvPdf} download="avriResume.pdf">
              <img src={require(`../data/imgs/icons/app/docCloud.png`)} alt="docCloud" />
              <p>Resume</p>
            </a>

            <div className="drop-link" style={itemStyle} onClick={openMediaPlayer}>
              <img src={require(`../data/imgs/icons/app/player.png`)} alt="Music" />
              <p> Music </p>
            </div>

            <Link className="drop-link" style={itemStyle} to="/aboutMe">
              <img src={require(`../data/imgs/icons/app/meDefault.png`)} alt="aboutMe" />
              <p>About Me</p>
            </Link>

            <a className="drop-link" style={itemStyle} onClick={() => {
              toggleColorMode();
              notifyWithToast(`${isDarkMode ? 'Light' : 'Dark'} mode is set !`, '',);
            }}>
              <img src={require(`../data/imgs/icons/app/light.png`)} alt="colorMode" />
              <p>{isDarkMode ? 'LightMode' : 'DarkMode'}</p>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

// https://icons8.com/icons/set/google // 48px